import type { ReactNode } from 'react';
import { Paper } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

type SurfaceProps = {
  children: ReactNode;
  sx?: SxProps<Theme>;
  selected?: boolean;
  accent?: string;
};

/** Themed card surface — the container used by every active-phase screen. */
export const Surface = ({ children, sx, selected, accent }: SurfaceProps) => (
  <Paper
    elevation={0}
    sx={[
      theme => ({
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${selected ? (accent ?? theme.palette.primary.main) : theme.ui.surfaceBorder}`,
        borderRadius: `${String(theme.ui.cardRadius)}px`,
        boxShadow: theme.ui.shadow,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- SxProps array spread is safe; MUI's type lacks the index signature that would allow it
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Paper>
);
